import { ExternalLink } from "lucide-react"

interface HistoryConversationLinkProps {
  workspaceId: string
  historyId: number
  conversationId: number
  children: React.ReactNode
}

const HistoryConversationLink = ({
  workspaceId,
  historyId,
  conversationId,
  children,
}: HistoryConversationLinkProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    // Open in new tab with before parameter to show conversations before the target
    const searchParams = new URLSearchParams({
      before: conversationId.toString(),
      view: "evaluation-context",
    })
    const url = `/workspaces/${workspaceId}/histories/${historyId.toString()}?${searchParams.toString()}`
    window.open(url, "_blank", "noopener,noreferrer")
  }

  return (
    <button
      onClick={handleClick}
      className="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-1 transition-colors"
    >
      {children}
      <ExternalLink className="h-3 w-3" />
    </button>
  )
}

export default HistoryConversationLink
